import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Box } from '@mui/material';
import BaseOptionChart from './BaseOptionChart';
import { ChartCategory } from 'contexts/DashboardContext';

// ----------------------------------------------------------------------

export interface ChartBarProps {
  charData: ChartCategory[];
  title: string;
  name: string;
  barColors?: string[];
  charType?: 'bar' | 'area';
}

export default function BoostBarChart({
  charData,
  title,
  name,
  barColors = [],
  charType = 'bar'
}: ChartBarProps) {
  const categories: string[] = charData.map((row: ChartCategory) => row.key);
  const data: number[] = charData.map((row: ChartCategory) => row.value);
  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '35%', border: 'none' } },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 0
    },
    xaxis: {
      categories
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          const yAxisLbl = Number.parseFloat(value.toString());
          if (yAxisLbl % 1 != 0) {
            return yAxisLbl.toFixed(1);
          }
          return yAxisLbl;
        }
      }
    },
    fill: { colors: barColors },
    tooltip: {
      x: {
        show: false
      },
      y: {
        formatter: (value) => {
          return parseFloat(value).toFixed(1);
        }
      },
      marker: { show: false }
    },
    title: {
      text: title,
      align: 'center'
    }
  });
  const series = [
    {
      name,
      data
    }
  ];

  return (
    <Box sx={{ p: 3, pb: 1 }} dir="ltr">
      <ReactApexChart type={charType} series={series} options={chartOptions} height={400} />
    </Box>
  );
}
